/* ==========================================================================
   Pawly Supply — collection.js
   Faceted filtering + sorting via the Section Rendering API, "Load more".
   ========================================================================== */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  class Facets {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId;
      this.form = $('[data-facets-form]', section);
      this.grid = $('[data-product-grid]', section);
      this.wrap = $('[data-grid-wrap]', section);
      this.facets = $('[data-facets]', section);
      this.timer = null;
      let untrap = null;

      if (this.form) {
        this.form.addEventListener('input', (e) => {
          if (e.target.type === 'number') { clearTimeout(this.timer); this.timer = setTimeout(() => this.apply(), 600); return; }
          this.apply();
        });
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });
      }
      section.addEventListener('change', (e) => { if (e.target.matches('[data-sort]')) this.apply(); });
      section.addEventListener('click', (e) => {
        const a = e.target.closest('[data-facet-remove]');
        if (a) { e.preventDefault(); this.load(a.href); }
        const clear = e.target.closest('[data-facets-clear]');
        if (clear) { e.preventDefault(); this.load(clear.dataset.facetsClear); }
        if (e.target.closest('[data-facets-open]')) { e.preventDefault(); this.facets.classList.add('is-open'); $('#FacetsOverlay').classList.remove('hidden'); window.Pawly.lockScroll(true); untrap = window.Pawly.trapFocus(this.facets); }
        if (e.target.closest('[data-facets-close]')) { e.preventDefault(); this.closeDrawer(); if (untrap) untrap(); }
        const more = e.target.closest('[data-load-more]');
        if (more) { e.preventDefault(); this.loadMore(more); }
      });
      const overlay = $('#FacetsOverlay');
      if (overlay) overlay.addEventListener('click', () => this.closeDrawer());
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeDrawer(); });
      window.addEventListener('popstate', () => this.load(window.location.href, false));
    }

    closeDrawer() {
      if (!this.facets) return;
      this.facets.classList.remove('is-open');
      const o = $('#FacetsOverlay'); if (o) o.classList.add('hidden');
      window.Pawly.lockScroll(false);
    }

    buildUrl() {
      const params = new URLSearchParams();
      if (this.form) {
        new FormData(this.form).forEach((v, k) => { if (v !== '') params.append(k, v); });
      }
      const sort = $('[data-sort]', this.section);
      if (sort && sort.value) params.set('sort_by', sort.value);
      const q = new URLSearchParams(window.location.search).get('q');
      if (q) params.set('q', q);
      return window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    }

    apply() { this.load(this.buildUrl()); }

    async load(url, push) {
      if (push !== false) window.history.pushState({}, '', url);
      this.wrap.classList.add('is-loading');
      const wasOpen = this.facets && this.facets.classList.contains('is-open');
      try {
        const sep = url.includes('?') ? '&' : '?';
        const res = await fetch(url + sep + 'section_id=' + this.sectionId);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-grid-wrap]', '[data-facets-body]', '[data-toolbar-left]', '[data-facets-foot]'].forEach((sel) => {
          const fresh = $(sel, doc), cur = $(sel, this.section);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        this.grid = $('[data-product-grid]', this.section);
        this.wrap = $('[data-grid-wrap]', this.section);
        if (wasOpen) this.facets.classList.add('is-open');
        // keep facet open/closed state intact (details elements re-rendered: open by default from markup)
      } catch (e) { /* noop */ } finally { this.wrap.classList.remove('is-loading'); }
    }

    async loadMore(btn) {
      const next = btn.dataset.loadMore;
      if (!next) return;
      btn.classList.add('is-loading'); btn.disabled = true;
      try {
        const sep = next.includes('?') ? '&' : '?';
        const res = await fetch(next + sep + 'section_id=' + this.sectionId);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const items = $$('[data-product-grid] > *', doc);
        items.forEach((li) => this.grid.appendChild(li));
        const freshMore = $('[data-load-more-wrap]', doc), curMore = $('[data-load-more-wrap]', this.section);
        if (freshMore && curMore) curMore.innerHTML = freshMore.innerHTML; else if (curMore) curMore.remove();
        const shown = $('[data-shown-count]', this.section);
        if (shown) shown.textContent = $$('[data-product-grid] > *', this.section).length;
      } catch (e) { btn.classList.remove('is-loading'); btn.disabled = false; }
    }
  }

  function boot() { $$('[data-collection-section]').forEach((s) => { if (!s.__facets) s.__facets = new Facets(s); }); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
